import { useCallback } from 'react';
import type React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReducedMotion } from 'framer-motion';

/** Scrolls to a home-page section, navigating home first when needed. */
export function useAnchorNavigation() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion();

  return useCallback(
    (id: string, after?: () => void) => (event: React.MouseEvent) => {
      event.preventDefault();
      after?.();
      if (pathname === '/') {
        document
          .getElementById(id)
          ?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        window.history.replaceState(window.history.state, '', `/#${id}`);
      } else {
        navigate(`/#${id}`);
      }
    },
    [pathname, navigate, reduceMotion]
  );
}
